import { render, staticRenderFns } from "./WarehousesListing.vue?vue&type=template&id=b98c0c90&scoped=true&lang=pug&"
import script from "./WarehousesListing.vue?vue&type=script&lang=js&"
export * from "./WarehousesListing.vue?vue&type=script&lang=js&"
import style0 from "./WarehousesListing.vue?vue&type=style&index=0&id=b98c0c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98c0c90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
